import styled, { AnyStyledComponent } from 'styled-components';
import { Input } from 'antd';

export const GenericInputStyle = styled(
  Input as unknown as AnyStyledComponent,
)``;
